var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"z-index":"205"},model:{value:(_vm.LOADING),callback:function ($$v) {_vm.LOADING=$$v},expression:"LOADING"}},[_c('v-progress-circular',{staticClass:"mx-auto",attrs:{"indeterminate":"","size":"64","color":"white"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }